export const environment = {
  production: true,
  Build_Timestamp: '10/23/2026 07:17:42 PM CDT',
  envName: 'QA' // Added for verification
};
